import { print, DocumentNode } from "graphql";
import { CustomResponse, BaseRecord, VariableOptions, DataProvider } from "@refinedev/core";
import { gmbhDataProvider, ggmbhDataProvider } from "../dataProvider";

async function executeGraphQLOperation<T extends BaseRecord>(
  dataProvider: DataProvider & Required<Pick<DataProvider, "custom">>,
  operation: DocumentNode,
  variables?: VariableOptions
): Promise<CustomResponse<T>> {
  if (!dataProvider) {
    throw new Error("DataProvider is required for executeGraphQLOperation");
  }

  return await dataProvider.custom<T>({
    url: "",
    method: "post",
    meta: {
      operation: print(operation),
      variables,
    },
  });
}

export const requestGmbh = async <T>(
  operation: DocumentNode,
  variables?: VariableOptions
): Promise<CustomResponse<T>> => {
  return executeGraphQLOperation<T & BaseRecord>(gmbhDataProvider, operation, variables) as Promise<CustomResponse<T>>;
};

export const requestGgmbh = async <T>(
  operation: DocumentNode,
  variables?: VariableOptions
): Promise<CustomResponse<T>> => {
  return executeGraphQLOperation<T & BaseRecord>(ggmbhDataProvider, operation, variables) as Promise<CustomResponse<T>>;
};
